"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TextareaMixin = require("../../mixins/components/TextareaMixin");
var _FormControl = require("../FormControl/FormControl");
/**
 * A basic [HTML textarea element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea).
 *
 * @since 3.0.0
 */
var Textarea = /*#__PURE__*/(0, _styledComponents.default)(_FormControl.FormControl).withConfig({
  displayName: "Textarea",
  componentId: "c11n-8-107-0__sc-ulc0xn-0"
})(["", ""], _TextareaMixin.TextareaMixin);
exports.Textarea = Textarea;
Textarea.displayName = 'Textarea';
Textarea.propTypes = {
  /**
   * Displays the textarea in an error state. Can also be inherited from a FormField parent.
   */
  error: _propTypes.default.bool,
  /**
   * Textareas are fluid by default which means they stretch to fill the entire width of their
   * container. When `fluid="false"`, the textarea's width is set to `auto`.
   */
  fluid: _propTypes.default.bool,
  /**
   * The [native textarea](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea)
   * "maxlength" property.
   */
  maxLength: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  /**
   * Determines whether the user can resize the textarea and in which directions.
   * Controls the CSS `resize` property.
   */
  resize: _propTypes.default.oneOf(['both', 'horizontal', 'vertical', 'none']),
  /**
   * The [native textarea](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea)
   * "rows" property.
   */
  rows: _propTypes.default.string,
  /**
   * Indicates the textarea is required. Can also be inherited from a FormField parent.
   */
  required: _propTypes.default.bool,
  /**
   * Displays the textarea in a disabled state. Can also be inherited from a FormField parent.
   */
  disabled: _propTypes.default.bool,
  /**
   * styled-components forwarded `as` component.
   * @ignore
   */
  forwardedAs: _propTypes.default.string,
  /**
   * Displays the textarea in a read-only state. Can also be inherited from a FormField parent.
   *
   * @since 8.27.0
   */
  readOnly: _propTypes.default.bool
};
Textarea.defaultProps = {
  fluid: true,
  resize: 'none',
  rows: '3',
  forwardedAs: 'textarea'
};

/** @component */